import React from 'react';
import ButtonAction from '../ui/Buttons/ButtonAction';
import IProdukt from '../../interfaces/IProdukt';
import { CartContext } from '../Cart/CartContext';
import { ProductWidgetContext } from './ProductWidgetContext';
import AddToCartButton from '../../assets/addToCart.animated.inline.svg';
import * as styles from './AddToCartButton.module.scss';

type Props = {
    produktTyp: IProdukt["produktTyp"];
}

export default (props: Props) => {
    const {produktTyp} = props;
    const {dispatch} = React.useContext(CartContext);
    const widgetState = React.useContext(ProductWidgetContext);
    const [addedToCart, setAddedToCart] = React.useState<boolean>(false);

    const { forms } = widgetState;
    const dispatchWidget = widgetState.dispatch;
    const widgetData = forms[produktTyp];

    const timeout = React.useRef(null);

    React.useEffect(() => {
        timeout.current = setTimeout(() => {
            setAddedToCart(false);
        }, 2500);

        return () => {
            clearTimeout(timeout.current);
        }
    }, [addedToCart]);

    // Submit
    const addToCart = () => {
            let configuration: {[key: string]: any} = {};

            let valid: boolean = true;
            for (const fieldName in widgetData.values) {
                // Validate:
                try {
                    widgetData.values[fieldName].validationFunc.validateSync(widgetData.values[fieldName].value);
                    if (widgetData.values[fieldName].error) {
                        dispatchWidget({type: "CLEAR_ERROR", name: fieldName, namespace: produktTyp,});
                    }
                } catch (e) {
                    valid = false;
                    dispatchWidget({type: "SET_ERROR", name: fieldName, namespace: produktTyp, message: e.message})
                }
                configuration[fieldName] = widgetData.values[fieldName].value;
            }
            delete configuration.product;
            delete configuration.menge;

            if (valid) {
                setAddedToCart(true);
                dispatch({type: "ADD_PRODUCT", product: widgetData.values.product.value, configuration, qty: widgetData.values.menge.value });
                dispatchWidget({type: "CLEAR_VALUE", name: "files", namespace: produktTyp});
                setTimeout(() => {
                    dispatch({type: "OPEN_MINI_CART"});
                }, 200);
            }
    }

    return <div>
        <ButtonAction onClick={addToCart} className={styles.button} icon={addedToCart ? "none" : "arrow"}>
            {!addedToCart && <span className={styles.text}>Anfragen</span>}
            {addedToCart && <AddToCartButton height="40" className={styles.added} />}
        </ButtonAction>
    </div>
}